@import '../../global/common.css';

:host {
    display: block;

    /* Styling for the auth-box buttons */
    --login-wall-auth-button-border: 2px solid var(--primary-color);
    --login-wall-auth-button-background-color: var(--white-color);

    /* Styling for the auth-box email-button */
    --login-wall-email-button-border: 2px solid var(--grey-color);
    --login-wall-email-button-background-color: var(--white-color);
    --login-wall-email-button-color: var(--text-color);
}

.title {
    margin: 0;

    font-size: 26px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;

    text-align: center;

    color: var(--text-color-2);
}

.subtitle {
    margin: 0;

    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 16px;

    text-align: center;

    color: var(--text-color);
}

.login-wall-container {
    display: flex;
    flex-direction: column;
    align-items: center;

    margin: 0 auto;
    padding: 30px 30px 50px 30px;
    max-width: 655px;

    background-color: var(--background-color);
    border: var(--container-border);
    border-radius: 10px;

    font-family: Roboto;
    color: var(--text-color);
}

.wall-icon {
    align-self: flex-start;
    color: var(--primary-color);
}

.content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap: 60px;

    padding: 5px 50px;
}

.info {
    display: flex;
    flex-direction: column;
    gap: 21px;
}

.auth-box {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: 305px;
}

.social-buttons{
    width: 100%;
}

.auth-buttons-container {
    display: flex;
    justify-content: left;
    flex-wrap: wrap;
    gap: 5%;
    width: 100%;
}

.auth-button {
    display: flex;
    justify-content: center;
    border: var(--login-wall-auth-button-border);
    border-radius: 4px;
    background-color: var(--login-wall-auth-button-background-color);
    cursor: pointer;
    width: 30%;
    padding: 10px;
    margin: 2% 0;
}

.auth-button img {
    width: 31px;
    height: 31px;
}

.more-socials{
    position: relative;
}

#authMoreButtonsContainerId{
    display: none;
}
#authMoreButtonsContainerId.options-active{
    display: flex;
}

.more-options {
    position: absolute;
    bottom: -16px;
    right: 0;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 0.75em;
}

.more-options::after {
    content: '';
    display: inline-block;
    position: relative;
    top: -2px;
    width: 0.5em;
    height: 0.5em;
    border-right: 2px solid var(--text-color);
    border-bottom: 2px solid var(--text-color);
    transform: rotate(45deg);
    margin-top: 2px;
    margin-left: 10px;
}

.more-options.options-active::after {
    transform: rotate(-135deg);
    top: 0;
}

.email-container{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;

    width: 100%;
}

.auth-divider {
    font-size: 16px;
    font-weight: 400;

    font-size: 16px;
    font-style: normal;
    font-weight: 400;

    margin-top: 30px;
    margin-bottom: 10px;
}

.email-auth {
    background-color: var(--login-wall-email-button-background-color);
    border: var(--login-wall-email-button-border);
    border-radius: 8px;

    cursor: pointer;

    width: 100%;
    height: 48px;

    font-family: Roboto;
    font-size: 16px;
    font-weight: 700;

    color: var(--login-wall-email-button-color);
}